import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getPartnerCardDetails } from 'modules/accommodations/features/reservations/api';

export const useQueryPartnerCardDetails = ({ calculationId }: { calculationId: string }) => {
  const {
    data: partnerCardDetailsData,
    isLoading: partnerCardDetailsIsLoading,
    isError: partnerCardDetailsIsError,
  } = useQuery(
    [QUERY_KEYS.RENTALS_ACCOMMODATION_PARTNER_CARD_DETAILS, calculationId],
    () => getPartnerCardDetails(calculationId),
    { enabled: !!calculationId },
  );

  return { partnerCardDetailsData, partnerCardDetailsIsLoading, partnerCardDetailsIsError };
};
